import type { ImeiHubServiceId } from '../components/ImeiHubSignalIcon'

export type ImeiFollowUpCheckDetail = {
  service: ImeiHubServiceId
  checkId: string
  /** Full 15-digit IMEI when available (hub can prefill and run). */
  imei?: string
}

export const IMEI_FOLLOW_UP_EVENT = 'redevicer:imei-follow-up-check'

export function dispatchImeiFollowUpCheck(detail: ImeiFollowUpCheckDetail): void {
  window.dispatchEvent(new CustomEvent<ImeiFollowUpCheckDetail>(IMEI_FOLLOW_UP_EVENT, { detail }))
}
